module.exports = __webpack_public_path__ + "static/media/osherImage.f5335e7a.png";